import { type PostNftTransferPayload } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { postNftTransfer } from '../data-access/api';

/**
 * @returns withdraw single collectible mutation object
 */
export const useMyCollectibleBasicWithdrawMutation = () =>
	useMutation({ mutationFn: (payload: PostNftTransferPayload) => postNftTransfer(payload) });
